module.exports = __webpack_public_path__ + "img/oldPeople2.d4660c40.png";